import { previewTokenActions } from '../../../actions';
import createReducer from '../../../utils/createReducer';

export const previewTokenReducer = createReducer(
  {},
  {
    [previewTokenActions.update.type]: (state, { payload }) => payload,
  },
);
